/**
 * OnboardSteps — indicatore di avanzamento dell'onboarding ("passo X/5").
 * Rende il flusso percepibilmente lineare: l'utente sa sempre dove si trova
 * e quanto manca. Da mettere subito sotto l'Header di ogni schermata del flusso.
 */
const LABELS = ['Identità', '24 parole', 'PIN', 'Nome'];
const TOTAL = LABELS.length;

export default function OnboardSteps({ step }) {
  const s = Math.max(1, Math.min(TOTAL, step));
  return (
    <div className="mb-3">
      <div className="flex justify-between items-center text-[12px] text-ink-dim mb-1">
        <span>Passo {s}/{TOTAL} · <span className="text-ink">{LABELS[s - 1]}</span></span>
        <span>{s === TOTAL ? 'ultimo' : `mancano ${TOTAL - s}`}</span>
      </div>
      <div className="flex gap-1">
        {LABELS.map((_, i) => (
          <div key={i} className={`h-1.5 flex-1 ${i < s ? 'bg-ink' : 'bg-ink-dim/30'}`} />
        ))}
      </div>
    </div>
  );
}
